import React from 'react';
import {Route} from 'react-router-dom';
import EzManageNav from './EzManageNav';

type EzManageNavRouteProps = React.ComponentProps<typeof Route> & {
  openLiveChat?: () => void;
};

const EzManageNavRoute: React.FC<EzManageNavRouteProps> = ({
  component,
  openLiveChat,
  render: routeRender,
  ...routeProps
}) => {
  const render = component
    ? (props: React.ComponentProps<typeof component>) => React.createElement(component, props)
    : routeRender;

  return (
    <Route
      {...routeProps}
      render={renderProps => {
        return (
          render && <EzManageNav openLiveChat={openLiveChat}>{render(renderProps)}</EzManageNav>
        );
      }}
    />
  );
};

export default EzManageNavRoute;
